module.exports = __webpack_public_path__ + "static/media/logo192.c2ead9a9.png";